import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { DatePipe } from '@angular/common'
import { DataTableDirective } from 'angular-datatables'
import { Subject } from 'rxjs/Subject'
import { BsModalService } from 'ngx-bootstrap/modal'
@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective) dtElement: DataTableDirective
  dtTrigger: Subject<any> = new Subject()
  subscription: Subscription
  transactionDataTableOptions: DataTables.Settings = {}
  form: FormGroup
  symbolValue
  mockupData
  sortMockup
  listHeader
  endYear
  startYear
  tradingDate
  listTable = []
  initTableFirstTime = false
  round = '5'
  asc = 1
  desc = -1

  constructor(
    private store: StoreService,
    private cpmService: CpmService,
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.listHeader = [
      'Security Symbol',
      'sort Date',
      'Effective date',
      'CA type',
      'Capital raised target',
      'Capital raised status',
      'No. of shares increase',
      'Subscription price',
      'Par',
      'Subscription value',
      'Ratio',
      'Serial',
      'Period',
      'No. of shares amount (M.shares)',
      '% Subscription'
    ]

    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )

    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.getInformation(response['securitySymbol'], this.round)
      })

    this.transactionDataTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      ordering: true,
      info: false,
      destroy: true,
      order: [[1, 'desc']],
      language: {
        emptyTable: 'No information found'
      },
      columnDefs: [
        { targets: 0, orderable: false, visible: false },
        { targets: 1, visible: false },
        { targets: 2, orderData: 1 },
        { targets: 3, orderable: true },
        { targets: 4, orderable: false },
        { targets: 5, orderable: true },
        { targets: 6, orderable: true },
        { targets: 7, orderable: false },
        { targets: 8, orderable: false },
        { targets: 9, orderable: true },
        { targets: 10, orderable: false },
        { targets: 11, orderable: false },
        { targets: 12, orderable: false },
        { targets: 13, orderable: false },
        { targets: 14, orderable: false }
      ]
    }
  }

  getInformation(symbol, round) {
    this.symbolValue = symbol

    if (this.initTableFirstTime) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy()
      })
    }

    this.listTable = []

    this.cpmService.getCapitalRaisedByTransaction(symbol, round).then(
      success => {
        // console.log(success, '-- success')
        const listData = success
        this.listTable = listData.map(x => {
          if (x.ratio !== null) {
            const splited = x.ratio
              .split(':')
              .map(y => Number(y)) as Array<string>
            x.ration = splited.join(' : ')
          }
          return x
        })

        if (!this.initTableFirstTime) {
          this.dtTrigger.next()
          this.initTableFirstTime = true
        } else {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.dtTrigger.next()
          })
        }
      },
      err => { }
    )
  }

  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }

  get ws_data_toExcel() {
    const ws_data = []

    const date = this.datePipe.transform(this.tradingDate, 'd MMM yyyy')

    ws_data.push(['Transaction'])
    ws_data.push([
      'Listed Company Capital Raised Statistics (Report date ' + date + ')'
    ])
    ws_data.push([
      'Effective date',
      'CA type',
      'Capital raised target',
      'Capital raised status',
      'No. of shares increase',
      'Subscription price',
      'Par',
      'Subscription value',
      'Ratio',
      'Serial',
      'Period',
      'No. of share amount (M.shares)',
      '% Subscription'
    ])

    this.listTable.map(obj => {
      const effectiveDate = this.datePipe.transform(
        obj.effectiveDate,
        'd MMM yyyy'
      )
      const startperiod = this.datePipe.transform(obj.startPeriod, 'd MMM yyy')
      const endperiod = this.datePipe.transform(obj.endPeriod, 'd MMM yyyy')
      let period
      let noAmount
      let percentSub
      let noIncrease
      let subPrice
      let totalSub

      if (startperiod !== null && endperiod !== null) {
        period = startperiod + ' - ' + endperiod
      }

      if (obj.noOfShareAmount !== null) {
        noAmount = Number(obj.noOfShareAmount)
      }

      if (obj.percentSubscription !== null) {
        percentSub = Number(obj.percentSubscription)
      }

      if (obj.noOfShareIncrease !== null) {
        noIncrease = Number(obj.noOfShareIncrease)
      }

      if (obj.subscriptionPrice !== null) {
        subPrice = Number(obj.subscriptionPrice)
      }

      if (obj.totalValueBySubscriptionPrice !== null) {
        totalSub = Number(obj.totalValueBySubscriptionPrice)
      }

      ws_data.push([
        effectiveDate,
        obj.corporateActionType,
        obj.capitalRaiseTarget,
        obj.capitalRaiseStatus,
        noIncrease,
        subPrice,
        obj.par,
        totalSub,
        obj.ration,
        obj.serial,
        period,
        noAmount,
        percentSub
      ])
    })

    return ws_data
  }

  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    this.startYear = +this.endYear - 4
  }
  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/transaction/transaction.component.ts